import { useQuery } from '@tanstack/react-query';
import { getCommunityMembers } from '../contactsRequest';

export const useCommunityMembers = () => {
  return useQuery({
    queryKey: ['community-members'],
    queryFn: getCommunityMembers,
  });
};
